import { render, staticRenderFns } from "./handle.vue?vue&type=template&id=36356bf4&scoped=true&"
import script from "./handle.vue?vue&type=script&lang=js&"
export * from "./handle.vue?vue&type=script&lang=js&"
import style0 from "./handle.vue?vue&type=style&index=0&id=36356bf4&scoped=true&lang=less&"
import style1 from "./handle.vue?vue&type=style&index=1&id=36356bf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36356bf4",
  null
  
)

export default component.exports